export default{
    apiKey: "AIzaSyAh3b58iLEq0rPhW2WC-T6g9rIHYk1fiHs",
    authDomain: "profile-0705.firebaseapp.com",
    databaseURL: "https://profile-0705.firebaseio.com",
    projectId: "profile-0705",
    storageBucket: "profile-0705.appspot.com",
    messagingSenderId: "227795397556"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js